module.exports = __webpack_public_path__ + "img/vertical_4_4_8019.0d1c4022.png";